// Copyright (c) 2016 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import AllPartsReturnsFacets from './all-part-requests-facets';
import ExportToExcel from '../../../shared/state/export-to-excel';
import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';
import PartReturnListWrapper from '../components/part-return-list-wrapper';
import PartReturnsWrapper from '../../shared/components/part-returns-wrapper';
import SearchFilters from '../state/search-filters';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

class AllPartRequests extends Component {

    componentWillUnmount() {

        this.props.actions.resetExportToExcelLayout();

    }

    getFacets() {

        return (
            <AllPartsReturnsFacets
                actions={this.props.actions}
                facets={this.props.facets}
            />
        );

    }

    render() {

        return (
            <PartReturnsWrapper
                actions={this.props.actions}
                allPartRequestsCount={this.props.allPartReturns.length}
                facets={this.getFacets()}
                hasSearchResultsLoaded={this.props.hasSearchResultsLoaded}
                isExportDisabled={this.props.allPartReturns.length < 1}
                openPartRequestsCount={this.props.openPartReturnsCount}
                searchByDropdown={this.props.searchByDropdown}
                searchQueryString={this.props.searchQueryString}
                searchResultsCount={this.props.searchResultsCount}
            >
                <PartReturnListWrapper
                    actions={this.props.actions}
                    allPartRequestsCount={this.props.allPartReturns.length}
                    busyCounter={this.props.busyCounter}
                    exportToExcel={this.props.exportToExcel}
                    facets={this.getFacets()}
                    hasSearchResultsLoaded={this.props.hasSearchResultsLoaded}
                    isExportDisabled={this.props.allPartReturns.length < 1}
                    openPartRequestsCount={this.props.openPartReturnsCount}
                    partReturns={this.props.allPartReturns}
                    searchByDropdown={this.props.searchByDropdown}
                    searchFilters={this.props.searchFilters}
                    searchQueryString={this.props.searchQueryString}
                    searchResultsCount={this.props.searchResultsCount}
                />
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
            </PartReturnsWrapper>
        );

    }

}

AllPartRequests.displayName = 'AllPartRequests';
AllPartRequests.propTypes = {
    actions: PropTypes.object.isRequired,
    allPartReturns: PropTypes.arrayOf(PropTypes.instanceOf(PartReturn)).isRequired,
    busyCounter: PropTypes.number.isRequired,
    exportToExcel: PropTypes.instanceOf(ExportToExcel).isRequired,
    facets: PropTypes.object.isRequired,
    hasSearchResultsLoaded: PropTypes.bool.isRequired,
    openPartReturnsCount: PropTypes.number.isRequired,
    searchByDropdown: PropTypes.object.isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    searchQueryString: PropTypes.string.isRequired,
    searchResultsCount: PropTypes.number.isRequired
};

export default AllPartRequests;



// WEBPACK FOOTER //
// ./src/part-requests/all-parts-requests/components/all-part-requests.js